/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export * from './external-routes-config';
export * from './external-routes.guard';
export * from './external-routes.module';
export * from './external-routes.service';
